export const INCLUDE_PLUGIN_DEFAULT_TRUE = 'include-default-true'
export const INCLUDE_PLUGIN_DEFAULT_FALSE = 'include-default-false'
export const INCLUDE_PLUGIN_REQUIRED = 'include-required'
export const INCLUDE_PLUGIN_NEVER = 'include-never'

export const COST_ALLOCATION_NOT_SET = 'NOT set'
export const COST_ALLOCATION_TAGS_ACTIVATED = 'tags activated; NO allocation rule'
export const COST_ALLOCATION_RULE_DEFINED = 'site cost allocation rule defined'
